import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiesuozhuangtai11",
  "use": "icon-jiesuozhuangtai11-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-jiesuozhuangtai11\">\r\n<title>jiesuozhuangtai</title>\r\n<path d=\"M15.215 14.333h-8.212c-1.66 0.006-3.003 1.354-3.003 3.014v7.345c0.006 1.66 1.354 3.003 3.014 3.003h13.057c1.652-0.012 2.986-1.351 2.992-3.003v-7.344c0-1.66-1.343-3.008-3.003-3.014h-2.288v-2.866c0-2.103 1.705-3.809 3.809-3.809s3.808 1.705 3.808 3.809c0 0.721 0.585 1.306 1.306 1.306s1.306-0.585 1.306-1.306c-0.141-3.428-2.961-6.134-6.392-6.134s-6.251 2.706-6.392 6.134v2.866zM13.945 17.218c0.983 0.197 1.69 1.063 1.687 2.066 0.003 0.343-0.079 0.681-0.238 0.985s-0.392 0.563-0.676 0.755v2.666c-0.001 0.154-0.033 0.306-0.094 0.447s-0.148 0.269-0.259 0.377-0.241 0.192-0.384 0.248c-0.143 0.057-0.296 0.084-0.45 0.081-0.639 0-1.158-0.515-1.164-1.153v-2.666c-0.835-0.556-1.16-1.625-0.776-2.552s1.37-1.452 2.353-1.255z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jiesuozhuangtai11.svg
// module id = 4+mW
// module chunks = 14